<template>
  <v-container>
    <v-card
      color="oug"
      class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24"
    >
      <v-card>
        <v-card-text>
          <v-avatar size="80">
            <img :src="getAvatar()" alt="OUG" />
          </v-avatar>
          <p></p>
          <h3>
            {{ this.currentUser.Firstname }} {{ this.currentUser.Surname }}
          </h3>
          <div>Username: {{ this.currentUser.Login }}</div>
          <div>Email: {{ this.currentUser.Email_Details }}</div>
          <div>
            DOB: {{ formatDate(currentUser.Date_of_Birth, "DD/MM/YYYY") }}
          </div>
          <div>Phone: {{ this.phoneNumber }}</div>
          <div>Gender: {{ this.profileGender }}</div>
          <div></div>
          <v-btn class="mt-1" outlined color="oug" to="EditDetails"
            >Edit Details</v-btn
          >
        </v-card-text>
        <v-divider></v-divider>
        <v-card color="oug">
          <v-expansion-panels focusable>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Address Details
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list>
                  <v-list-item>{{ this.address }}</v-list-item>
                </v-list>
                <v-divider class="mb-3"></v-divider>
                <v-btn outlined color="oug" @click="FeatureNotReady = true"
                  >Add New Address</v-btn
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Phone Numbers
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list>
                  <v-list-item>{{ this.phoneNumber }}</v-list-item>
                </v-list>
                <v-divider class="mb-3"></v-divider>
                <v-btn outlined color="oug" @click="FeatureNotReady = true"
                  >Add New Phone Number</v-btn
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Email Addresses
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list>
                  <v-list-item>{{ this.homeEmail }}</v-list-item>
                </v-list>
                <v-divider class="mb-3"></v-divider>
                <v-btn outlined color="oug" @click="FeatureNotReady = true"
                  >Add New Email Address</v-btn
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Blue Card Details
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list>
                  <v-list-item>Blue Card No: {{ this.blueCardNo }}</v-list-item>
                  <v-list-item
                    >Blue Card Expiry: {{ this.blueCardExpiry }}</v-list-item
                  >
                </v-list>
                <v-divider class="mb-3"></v-divider>
                <v-btn
                  class="mb-3"
                  outlined
                  color="oug"
                  @click="blueCardNoDialog = true"
                  >Add New Blue Card Number</v-btn
                >
                <v-btn outlined color="oug" @click="blueCardExpiryDialog = true"
                  >Add New Blue Card Expiry Date</v-btn
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-dialog v-model="blueCardNoDialog" max-width="500px">
            <v-card>
              <v-card-title> Add a blue card number below </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="newBlueCardNo"
                  label="Blue Card Number"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn color="red" text @click="blueCardNoDialog = false">
                  Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  text
                  @click="saveToTable(290, newBlueCardNo)"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="blueCardExpiryDialog" max-width="500px">
            <v-card>
              <v-card-title> Add a blue card expiry below </v-card-title>
              <v-card-text>
                <v-col cols="12" lg="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Expiry"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-card-text>
              <v-card-actions>
                <v-btn color="red" text @click="blueCardExpiryDialog = false">
                  Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  text
                  @click="saveToTable(309, computedDateFormatted)"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="FeatureNotReady" max-width="500px">
            <v-card>
              <v-card-title> Feature Not Available </v-card-title>
              <v-card-text>
                <p>
                  This feature is not currently available for this version of
                  the App. If you wish to update these details on your OwnUrGoal
                  Profile, please do so from the original OwnUrGoal App.
                </p>
                <p>
                  <b
                    >In this current version, you can update your Blue Card
                    Details from this Profile section.</b
                  >
                </p>
                <p>
                  Please contact OUG Support at support@ownurgoal.zendesk.com if
                  you have any further issues. We apologize for any
                  inconvenience.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn color="red" text @click="FeatureNotReady = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { authComputed, getUser } from "../veux/helpers";
import { formatDate } from "../common/Functions/daysFunctons";
import axios from "axios";
import { getGenderByCode } from "../common/Functions/genderFunctions";

export default {
  data: (vm) => ({
    formatDate,
    getGenderByCode,
    blueCardNoDialog: false,
    blueCardExpiryDialog: false,
    newBlueCardNo: "",
    newBlueCardExpiry: "",
    address: "",
    phoneNumber: "",
    homeEmail: "",
    blueCardNo: "",
    blueCardExpiry: "",
    FeatureNotReady: false,
    profileGender: "",
    Code: 0,
    menu2: false,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateFormatted: vm.formatExpiryDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    Descriptions: [
      { code: 290, Description: "Blue Card No" },
      { code: 309, Description: "Blue Card Expiry" },
    ],
  }),
  created() {
    this.getUserDetails();
    // this.getDBGender();
  },
  methods: {
    getUserDetails() {
      let userGender = parseInt(this.currentUser.Gender)
      this.profileGender = getGenderByCode(userGender);
      let contactDetails = JSON.parse(
        localStorage.getItem("Coach")
      ).contact_details;
      // console.log("contactDetails", contactDetails);
      contactDetails.forEach((element) => {
        if (element.Type === 1) {
          this.address = element.Description;
        }
        if (element.Code === 8) {
          this.phoneNumber = element.Description;
        }
        if (element.Code === 3) {
          this.homeEmail = element.Description;
        }
        if (element.Code === 290) {
          this.blueCardNo = element.Description;
        }
        if (element.Code === 309) {
          this.blueCardExpiry = element.Description;
        }
      });
    },

    checkExisting(code) {
      // lookup Coach local store and return Contact_Details_id if found otherwise 0
      let retid = 0;
      let coach = JSON.parse(localStorage.getItem("Coach")).contact_details;
      let index = coach.findIndex((ele) => {
        return ele.Code == code;
      });
      // In index > 0 found existion record so update local store
      if (index > 0) {
        retid = coach[index].Contact_Details_id;
      }
      return retid;
    },
    UpdateLocalData(oParsedObject, response) {
      // load the entire Coach Data
      let coach = JSON.parse(localStorage.getItem("Coach"));
      // If Update
      if (oParsedObject.Action == "UPDATE") {
        // Loop through .contact_details to see if a match
        coach.contact_details.find((ele) => {
          if (ele.Code == oParsedObject.Payload.Type) {
            ele.Description = oParsedObject.Payload.Description;
            return true;
          }
          return false;
        });
      } else {
        // Insert so insert data
        coach.contact_details.push({
          Contact_Details_id: response.data.result.insertId,
          Contact_id: oParsedObject.Payload.Contact_id,
          Description: oParsedObject.Payload.Description,
          Detail: this.Descriptions.find((ele) => {
            return ele.code == oParsedObject.Payload.Type;
          }).Description,
          Details: "",
          Code: oParsedObject.Payload.Type,
        });
      }
      switch (oParsedObject.Payload.Type) {
        case 290:
          this.blueCardNo = oParsedObject.Payload.Description;
          break;
        case 309:
          this.blueCardExpiry = oParsedObject.Payload.Description;
          break;
        default:
          break;
      }
      localStorage.setItem("Coach", JSON.stringify(coach));
    },
    getAvatar() {
      // Set default to not logged in
      let result = require("../assets/logo.png");
      if (this.loggedIn) {
        // if logged in then check Profile photo
        this.currentUser.Photo
          ? (result = `https://admin.ownurgoal.net.au/_lib/file/OUGImages/${this.currentUser.Photo}`)
          : (result = require("../assets/no_profile_picture.png"));
      }
      return result;
    },

    saveToTable(code, value) {
      return new Promise((resolve, reject) => {
        let id = this.checkExisting(code);
        let jsonDetails = {
          Contact_Details_id: id,
          Contact_id: this.currentUser.Contact_id,
          Type: code,
          Description: value,
          Details: "",
        };
        let oParsedObject = {
          Payload: jsonDetails,
          Table: "Contact_Details",
          Primary_Key: "Contact_Details_id",
          Action: id === 0 ? "INSERT" : "UPDATE",
        };
        const baseURL = "https://server.ownurgoal.net.au/gen/EditTable";
        axios
          .post(baseURL, oParsedObject)
          .then((response) => {
            this.UpdateLocalData(oParsedObject, response);
            this.$toast.success(
              `Successfully Updated your Profile Information`,
              {
                timeout: 2000,
              }
            );
            (this.blueCardNoDialog = false),
              (this.blueCardExpiryDialog = false),
              resolve(response.data);
          })
          .catch((error) => {
            this.$toast.error(
              `OUG could not update your profile information - contact support@ownurgoal.zendesk.com`,
              {
                timeout: 4000,
              }
            );
            reject(error);
          });
      });
    },
    formatExpiryDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  computed: {
    ...authComputed,
    ...getUser,
    computedDateFormatted() {
      return this.formatExpiryDate(this.date);
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatExpiryDate(this.date);
    },
  },
};
</script>

<style>
</style>